module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showDragFiles) ? _c('div', {
    staticClass: "drop_zone",
    on: {
      "drop": _vm.drop_handler,
      "dragleave": function($event) {
        _vm.showDragFiles = false
      },
      "dragover": function($event) {
        $event.preventDefault();
      },
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._t("dropzone", [_c('div', {
    staticClass: "dragdropfiles"
  }, [_vm._v("Drop your files here.")])])], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d0ac81b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Dropzone.vue
// module id = 993
// module chunks = 2 6